/**
 * Information about the platform Bridge is running on. `data` is platform specific.
 */
export type Platform = {
	kind: PlatformKind
	username?: string
	data?: unknown
}

export enum PlatformKind {
	ADVANCEDMD = 'advancedmd',
	ATHELAS = 'athelas',
	ATHENA = 'Athena',
	AZALEA = 'azalea',
	AZARA = 'azara',
	CAREECO = 'careeco',
	CLINICIENT = 'clinicient',
	CROSSTX = 'crosstx',
	ECW = 'eCW',
	ELATION = 'Elation',
	EMPOWER = 'empower',
	GGASTRO = 'ggastro',
	HELLONOTE = 'hellonote',
	HENO = 'heno',
	IKNOWMED = 'iknowmed',
	MATRIXCARE = 'matrixcare',
	MODMED = 'modmed',
	NETHEALTH = 'nethealth',
	NETSMART = 'netsmart',
	NEXTGEN = 'nextgen',
	OFFICEALLY = 'Office Ally',
	ONCOEMR = 'oncoemr',
	POINTCLICKCARE = 'pointclickcare',
	PRACTICEFUSION = 'practicefusion',
	PROMPT = 'prompt',
	PTEVERYWHERE = 'pteverywhere',
	PTPRACTICEPRO = 'ptpracticepro',
	RAINTREE = 'raintree',
	SIRRUS = 'sirrus',
	STRATAEMR = 'strataemr',
	STRATUS = 'stratus',
	STRIDE = 'stride',
	THRIVE = 'thrive',
	TEBRA = 'tebra',
	TOUCHWORKS = 'touchworks',
	TURBOPT = 'turbopt',
	WEBPT = 'webpt',
	OTHER = 'Other'
}
